import { useEffect } from "react";

/**
 * Tiny SEO helper — sets <title> + meta description per route without
 * pulling in react-helmet. Keeps tags reverting to the index.html defaults
 * (HomePage) on unmount so search-engine snippets stay clean.
 */
export default function useSeo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
